module.exports = __webpack_public_path__ + "static/tv-2f6e54ca16553f71e1ba9327809df979.png";